import Banner from "../components/Banner";

export default function Home() {
   return (
      <>
         <Banner />
      </>
   );
}
